import React, { useEffect } from "react";
import { TableRow, TableCell } from "../../design/table";
import { useParticipant } from "../../contexts/ParticipantContext";
import { useEventType } from "../../contexts/EventTypeContext";
import moment from "moment";
import EventTypeBadge from "../../components/EventTypeBadge";
import EventSubtypeBadge from "../../components/EventSubtypeBadge";
import { Event } from "../../models/Event";

interface SelectEventListItemProps {
  event: Event;
  onClick: () => void;
}

const SelectEventListItem: React.FC<SelectEventListItemProps> = ({
  event,
  onClick,
}) => {
  const { participants } = useParticipant();
  const { eventTypes, eventSubtypes } = useEventType();

  return (
    <TableRow key={event._id} onClick={onClick}>
      <TableCell className={"font-bold"}>
        {event.eventDate && moment(event.eventDate).format("llll")}
      </TableCell>
      <TableCell>
        {event.participants &&
          Array.from(event.participants)
            .map((pId) => (participants || []).find((p) => p._id === pId)?.name)
            .join(", ")}
      </TableCell>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        <div className="flex flex-row space-x-4">
          {event.eventType && (
            <EventTypeBadge
              eventTypeId={event.eventType}
              eventTypes={eventTypes}
            />
          )}
          {event.eventSubtype && (
            <EventSubtypeBadge
              eventSubtypeId={event.eventSubtype}
              eventSubtypes={eventSubtypes}
            />
          )}
        </div>
        {event.description}
      </TableCell>
    </TableRow>
  );
};

export default SelectEventListItem;
